export const EVENT_TYPES = [
    // { value: 'MULTIMEDIA', label: 'str.event.filter.multimedia' },
    { value: 'INCIDENT', label: 'str.event.filter.incident' },
    // { value: 'SCAN', label: 'str.event.filter.scan' },
    { value: 'SOS_ALERT', label: 'str.event.filter.sos_alert' },
    // { value: 'START_PATROL', label: 'str.event.filter.start_patrol' },
    // { value: 'END_PATROL', label: 'str.event.filter.end_patrol' },
    { value: 'FAILURE_PATROL', label: 'str.event.filter.failure_patrol' },
    { value: 'CANCEL_PATROL', label: 'str.event.filter.cancel_patrol' },
    { value: 'OUTSIDE_GEOFENCE', label: 'str.event.filter.outside_geofence' },
]

export const MONITOR_EVENT_FILTER_OPTIONS = EVENT_TYPES.map(item => ({
    type: item.value,
    label: item.label,
}))

export const MONITOR_EVENT_FILTER_TYPES = MONITOR_EVENT_FILTER_OPTIONS.map(item => item.type)

export const getDefaultMonitorEventFilterOptions = () => {
    return MONITOR_EVENT_FILTER_OPTIONS.map(item => ({ ...item }))
}

export const normalizeMonitorEventFilterOptions = options => {
    const normalizedOptions = []
    const optionsByType = new Map()
    const fallbackLabelByType = new Map(MONITOR_EVENT_FILTER_OPTIONS.map(item => [item.type, item.label]))

    if (Array.isArray(options)) {
        options.forEach(item => {
            if (!item) return

            const type = typeof item === 'string' ? item : item.type
            if (!type || optionsByType.has(type)) return

            const label = typeof item === 'object' ? item.label || fallbackLabelByType.get(type) || type : fallbackLabelByType.get(type) || type
            const normalizedItem = { type, label }
            optionsByType.set(type, normalizedItem)
            normalizedOptions.push(normalizedItem)
        })
    }

    // OUTSIDE_GEOFENCE is emitted by the ShieldGo realtime pipeline even while
    // older helper endpoints still return the legacy option list.
    if (normalizedOptions.length > 0 && !optionsByType.has('OUTSIDE_GEOFENCE')) {
        const outsideGeofence = MONITOR_EVENT_FILTER_OPTIONS.find(item => item.type === 'OUTSIDE_GEOFENCE')
        if (outsideGeofence) normalizedOptions.push({ ...outsideGeofence })
    }

    return normalizedOptions.length > 0 ? normalizedOptions : getDefaultMonitorEventFilterOptions()
}

export const createDefaultMonitorEventFilters = (options = getDefaultMonitorEventFilterOptions()) => {
    return normalizeMonitorEventFilterOptions(options).map(item => ({
        type: item.type,
        label: item.label,
        enabled: true,
    }))
}

export const normalizeMonitorEventFilters = (filters, options = getDefaultMonitorEventFilterOptions()) => {
    const normalizedOptions = normalizeMonitorEventFilterOptions(options)
    const validTypes = normalizedOptions.map(item => item.type)
    const enabledByType = new Map()

    if (Array.isArray(filters)) {
        filters.forEach(item => {
            if (!item) return

            if (typeof item === 'string' && validTypes.includes(item)) {
                enabledByType.set(item, true)
                return
            }

            if (typeof item === 'object' && validTypes.includes(item.type)) {
                enabledByType.set(item.type, item.enabled !== false)
            }
        })
    }

    return normalizedOptions.map(item => ({
        type: item.type,
        label: item.label,
        enabled: enabledByType.has(item.type) ? enabledByType.get(item.type) : true,
    }))
}

export const getEnabledMonitorEventTypes = (filters, options = getDefaultMonitorEventFilterOptions()) => {
    return normalizeMonitorEventFilters(filters, options)
        .filter(item => item.enabled === true)
        .map(item => item.type)
}

export const EVENT_STATUS = {
    ACTIVE: 'ACTIVE',
    ARCHIVED: 'ARCHIVED',
}

export const EVENT_CHART_TYPES = ['FAILURE_PATROL', 'SOS_ALERT', 'INCIDENT']
